export const Searcher = {
	normalizeString(value: string): string {
		return value
			.toLowerCase()
			.trim()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '');
	},
};
